var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "fixedBox" }, [
      _c("div", { staticClass: "topBox" }, [
        _c("div", { staticClass: "backIcon", on: { click: _vm.back } }),
        _vm._v(" "),
        _c("div", { staticClass: "topTitle" }, [
          _vm._v(_vm._s(_vm.infoData.doctorName))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "rule", staticStyle: { opacity: "0" } }, [
          _vm._v("详情")
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "chatBox" }, [
      _c(
        "ul",
        {
          staticClass: "contentBox",
          class: {
            active: _vm.boxStatus || _vm.emojiStatus,
            active2: _vm.moreStatus
          },
          attrs: { id: "box" }
        },
        _vm._l(_vm.list, function(item, index) {
          return _c("li", { staticStyle: { "margin-bottom": ".28rem" } }, [
            (index + 1) % 4 == 1 || index == _vm.list.length - 1
              ? _c(
                  "div",
                  {
                    staticStyle: {
                      "text-align": "center",
                      "margin-bottom": ".15rem"
                    }
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm._f("time")(item.createTime)) +
                        "\n                    "
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                class: {
                  chatLeft: item.chatType == 1,
                  chatRight: item.chatType == 0
                },
                attrs: { id: "item" }
              },
              [
                item.chatType == 1 && _vm.mipDoctor
                  ? _c(
                      "div",
                      {
                        staticClass: "tx",
                        style: {
                          background:
                            "url(" +
                            _vm.EnvUrl +
                            _vm.infoData.doctorPhoto +
                            ") no-repeat center/cover"
                        }
                      },
                      [_c("div", { staticClass: "jtLeft" })]
                    )
                  : _vm._e(),
                _vm._v(" "),
                item.contentType == 1
                  ? _c("img", {
                      staticStyle: {
                        width: "3rem",
                        height: "3rem",
                        "object-fit": "cover",
                        "margin-top": ".2rem"
                      },
                      attrs: {
                        防止转换: "",
                        src: item.content,
                        preview: "",
                        "preview-text": ""
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                item.contentType == 4
                  ? _c("img", {
                      staticStyle: {
                        width: "3rem",
                        height: "3rem",
                        "object-fit": "cover",
                        "margin-top": ".2rem"
                      },
                      attrs: {
                        防止转换: "",
                        src: item.content[0],
                        preview: "",
                        "preview-text": ""
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                item.contentType == 2
                  ? _c("div", { staticStyle: { "margin-top": ".2rem" } }, [
                      item.chatType == 0
                        ? _c("img", {
                            staticStyle: { width: "1.91rem", height: ".59rem" },
                            attrs: {
                              src: require("assets/audioLeft.png"),
                              alt: ""
                            },
                            on: {
                              click: function($event) {
                                _vm.muiscPlay(item.content)
                              }
                            }
                          })
                        : _c("img", {
                            staticStyle: { width: "1.91rem", height: ".59rem" },
                            attrs: {
                              src: require("assets/audioRight.png"),
                              alt: ""
                            },
                            on: {
                              click: function($event) {
                                _vm.muiscPlay(item.content)
                              }
                            }
                          })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                (item.contentType == 0 || item.contentType == 3) &&
                item.chatType == 1
                  ? _c("span", {
                      staticStyle: {
                        "word-break": "break-word",
                        "margin-top": ".2rem",
                        "max-width": "4.63rem",
                        padding: ".17rem",
                        background: "#fff",
                        "border-radius": ".15rem"
                      },
                      domProps: { innerHTML: _vm._s(_vm.isUrl(item.content)) }
                    })
                  : _vm._e(),
                _vm._v(" "),
                (item.contentType == 0 || item.contentType == 3) &&
                item.chatType != 1
                  ? _c("span", {
                      staticStyle: {
                        "word-break": "break-word",
                        "margin-top": ".2rem",
                        "max-width": "4.63rem",
                        padding: ".17rem",
                        background: "#408BFB",
                        color: "#fff",
                        "border-radius": ".15rem"
                      },
                      domProps: { innerHTML: _vm._s(_vm.isUrl(item.content)) }
                    })
                  : _vm._e(),
                _vm._v(" "),
                item.chatType != 1
                  ? _c("div", { staticClass: "zj" }, [
                      _c("div", { staticClass: "jtRight" })
                    ])
                  : _vm._e()
              ]
            )
          ])
        })
      ),
      _vm._v(" "),
      _c("div", { staticClass: "fixed" }, [
        _vm.showInput
          ? _c("div", { staticClass: "inputBox" }, [
              _vm.replyStatus
                ? _c("div", {
                    attrs: { contenteditable: "true", id: "sendInput" },
                    on: {
                      focus: function($event) {
                        _vm.getFocus()
                      },
                      input: function($event) {
                        _vm.changeInput()
                      },
                      blur: function($event) {
                        _vm.changeUnrealHits()
                      }
                    },
                    model: {
                      value: _vm.content,
                      callback: function($$v) {
                        _vm.content = $$v
                      },
                      expression: "content"
                    }
                  })
                : _c(
                    "div",
                    {
                      staticStyle: { background: "#eee" },
                      attrs: { contenteditable: "false", id: "sendInput" },
                      model: {
                        value: _vm.content,
                        callback: function($$v) {
                          _vm.content = $$v
                        },
                        expression: "content"
                      }
                    },
                    [_vm._v(_vm._s(_vm.noReplyReason))]
                  ),
              _vm._v(" "),
              _c("div", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.emojiStatus,
                    expression: "!emojiStatus"
                  }
                ],
                staticClass: "emojiIcon",
                on: { click: _vm.showEmoji }
              }),
              _vm._v(" "),
              _c("div", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.emojiStatus,
                    expression: "emojiStatus"
                  }
                ],
                staticClass: "emojiIcon2",
                on: {
                  click: function($event) {
                    _vm.emojiStatus = false
                  }
                }
              }),
              _vm._v(" "),
              !_vm.content
                ? _c("div", {
                    staticClass: "more",
                    on: { click: _vm.showMore }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.content
                ? _c(
                    "div",
                    { staticClass: "button", on: { click: _vm.submit } },
                    [
                      _vm._v(
                        "\n                        发送\n                    "
                      )
                    ]
                  )
                : _vm._e()
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.chatQuestion && _vm.chatQuestion.times === 0
          ? _c("div", { staticClass: "toPayBox" }, [
              _c(
                "div",
                {
                  staticClass: "toPayBtn",
                  on: {
                    click: function($event) {
                      _vm.to(
                        "payServer?doctorId=" +
                          _vm.chatDoctor.doctorId +
                          "&questionId=" +
                          _vm.chatQuestion.questionId
                      )
                    }
                  }
                },
                [_vm._v("购买回复机会")]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "ul",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.boxStatus,
                expression: "boxStatus"
              }
            ],
            staticClass: "wordBox"
          },
          _vm._l(_vm.baiduCommonPhraseList, function(item) {
            return _c(
              "li",
              {
                on: {
                  click: function($event) {
                    _vm.toWord(item.phraseContent)
                  }
                }
              },
              [
                _vm._v(
                  "\n                        " +
                    _vm._s(item.phraseContent) +
                    "\n                    "
                )
              ]
            )
          })
        ),
        _vm._v(" "),
        _c(
          "ul",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.emojiStatus,
                expression: "emojiStatus"
              }
            ],
            staticClass: "emojiBox"
          },
          [
            _c(
              "ul",
              _vm._l(_vm.emojiList, function(item) {
                return _c(
                  "li",
                  {
                    on: {
                      click: function($event) {
                        _vm.emojiSected(item.char)
                      }
                    }
                  },
                  [_vm._v(_vm._s(item.char) + "\n                        ")]
                )
              })
            )
          ]
        ),
        _vm._v(" "),
        _vm.moreStatus
          ? _c("ul", { staticClass: "moreBox" }, [
              _vm.bespeakSwitch.photo
                ? _c("li", [
                    _c("div", { staticClass: "moreItem mi1" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "moreItemName" }, [_vm._v("相册")])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.bespeakSwitch.voice
                ? _c(
                    "li",
                    {
                      on: {
                        click: function($event) {
                          _vm.jump(1)
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "moreItem mi2" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "moreItemName" }, [
                        _vm._v("语音")
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.bespeakSwitch.video
                ? _c(
                    "li",
                    {
                      on: {
                        click: function($event) {
                          _vm.jump(2)
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "moreItem mi3" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "moreItemName" }, [
                        _vm._v("视频")
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.bespeakSwitch.phone
                ? _c(
                    "li",
                    {
                      on: {
                        click: function($event) {
                          _vm.to(
                            "complaint?doctorId=" +
                              _vm.chatDoctor.doctorId +
                              "&questionId=" +
                              _vm.chatQuestion.questionId
                          )
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "moreItem mi4" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "moreItemName" }, [
                        _vm._v("电话")
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.bespeakSwitch.shake
                ? _c(
                    "li",
                    {
                      on: {
                        click: function($event) {
                          _vm.to(
                            "complaint?doctorId=" +
                              _vm.chatDoctor.doctorId +
                              "&questionId=" +
                              _vm.chatQuestion.questionId
                          )
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "moreItem mi5" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "moreItemName" }, [
                        _vm._v("抖一抖")
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.bespeakSwitch.reminder
                ? _c(
                    "li",
                    {
                      on: {
                        click: function($event) {
                          _vm.to(
                            "complaint?doctorId=" +
                              _vm.chatDoctor.doctorId +
                              "&questionId=" +
                              _vm.chatQuestion.questionId
                          )
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "moreItem mi6" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "moreItemName" }, [
                        _vm._v("催单")
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.bespeakSwitch.notes
                ? _c(
                    "li",
                    {
                      on: {
                        click: function($event) {
                          _vm.to(
                            "complaint?doctorId=" +
                              _vm.chatDoctor.doctorId +
                              "&questionId=" +
                              _vm.chatQuestion.questionId
                          )
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "moreItem mi7" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "moreItemName" }, [
                        _vm._v("笔记")
                      ])
                    ]
                  )
                : _vm._e()
            ])
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5d7a5a0a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d7a5a0a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/reply.vue
// module id = null
// module chunks = 